import Select from 'react-select';
import { countriesList } from '@/src/utils/countriesList';
import { useEffect, useState } from 'react';

export default function CountrySelector({
  onChange = () => {},
  labelledby = 'country-label',
  country = '',
  placeholder,
}: {
  onChange: any;
  labelledby?: string;
  country?: string;
  placeholder?: string;
}) {
  const findCountry = (code: string) =>
    countriesList.find((c) => c.value.toLowerCase() === code.toLowerCase()) || null;

  const [currentValue, setCurrentValue] = useState(findCountry(country));

  useEffect(() => {
    setCurrentValue(findCountry(country));
  }, [country]);

  return (
    <Select
      placeholder={placeholder}
      aria-labelledby={labelledby}
      options={countriesList}
      value={currentValue}
      getOptionLabel={(x) => x.label}
      getOptionValue={(x) => x.value}
      onChange={(option) => {
        setCurrentValue(option);
        onChange(option);
      }}
      classNames={{
        control: () => 'text-black bg-white p-2 rounded-sm',
        option: () => 'p-2',
        menu: () => 'bg-white text-black',
      }}
      unstyled={true}
    />
  );
}
